import React  from 'react';
  
export const reportsAnalyticsConfig = [
  // {
  //   auth: ['user'],
  //   routes: [
  //     {
  //       path: '/reviews',
  //       component: React.lazy(() => import('./ReviewsTabs')),
  //     },
  //   ],
  // }, 
  {
    auth: ['user'],
    routes: [
      {
        path: '/patient-statistics',
        component: React.lazy(() => import('./PatientStat')),
      },
    ],
  }, 
  {
    auth: ['user'],
    routes: [
      {
        path: '/complaints-stat',
        component: React.lazy(() => import('./ComplaintsStat')),
      },
    ],
  }, 
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/reviews-ratings',
        component: React.lazy(() => import('./ReviewsRatings')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/reviews-ratings/practitioner-review',
        component: React.lazy(() => import('./PractitionerReview')),
      },
    ],
  },
]